import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopOnDutyChange(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="xs" type="com_input pop_duty_change">
      <h2 className="pop_tit">당직자 변경</h2>
      <div className="content_container scroll mb_no">
        <div className="pop_tit_sub">요청할 당직자 선택</div>
        <ul className="com_input_sec">
          <li className="input_field">
            <select name="" id="" className="select">
              <option value="">김관리103</option>
            </select>
          </li>
          <li>
            <div className="info_txt">요청한 당직자가 당직일까지 승인을 하지 않을경우 변경되지 않고 그대로 진행됩니다.</div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopOnDutyChange;
